import {ChangeDetectionStrategy, Component, HostBinding, Input} from '@angular/core'
import {faAngleRight} from '@fortawesome/pro-regular-svg-icons/faAngleRight'

@Component({
  selector: 'cft-breadcrumb, a[cft-breadcrumb], span[cft-breadcrumb]',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class BreadcrumbComponent {
  @Input()
  showSeparator = true

  @HostBinding('class.active')
  @Input()
  active = false

  @HostBinding('class.light')
  @Input()
  light = true

  readonly separatorIcon = faAngleRight
}
